import React from "react";
import Modal from "src/Components/Modal/Modal";
import { CommonTableUI } from "src/Tables/TableTemplate/common";
import TableTemplate from "src/Tables/TableTemplate/tableTemplate";
import {
  getPortfoSegregationTable,
  getPortfoSegregationDetailsTable,
} from "src/Requests/portfolioGroups";
import type {
  IPortfoSegregationSearchParams,
  IPortfoSegregationTableReport,
  IPortfoSegregationDetailsSearchParams,
  IPortfoSegregationDetailsTableReport,
} from "src/Interfaces/portfolioGroups";

interface IPortfoSegregationModalProps {
  accountId: number;
  tag: string;
  onClose: () => void;
}

const PortfoSegregationModal: React.FC<IPortfoSegregationModalProps> = ({
  accountId,
  tag,
  onClose,
}) => {
  const prevSegregationRowRef = React.useRef<number | null>(null);
  const [detailsSearchParams, setDetailsSearchParams] =
    React.useState<IPortfoSegregationDetailsSearchParams | null>(null);
  const [selectedSegregationRow, setSelectedSegregationRow] =
    React.useState<IPortfoSegregationTableReport | null>(null);

  const segregationSearchParams: IPortfoSegregationSearchParams = {
    accountId,
    tag,
  };

  const segregationRowClickHandler = (row: IPortfoSegregationTableReport) => {
    if (!row.hasDetail) return;
    if (prevSegregationRowRef.current === row.id) return;
    prevSegregationRowRef.current = row.id;
    setSelectedSegregationRow(row);
    setDetailsSearchParams({
      insId: row.insId,
      accountId: row.accountId,
      assetType: row.assetType,
    });
  };

  const modalUI = (
    <div className="flex flex-col gap-3 w-fit max-w-full min-w-0">
      <TableTemplate<
        IPortfoSegregationSearchParams,
        IPortfoSegregationTableReport
      >
        getDataTable={getPortfoSegregationTable}
        searchParameters={segregationSearchParams}
        TableUI={({ reports, onAction, sortingType, setSortingType }) => (
          <CommonTableUI
            reports={reports}
            onAction={onAction}
            sortingType={sortingType}
            setSortingType={setSortingType}
            onTableRowClick={segregationRowClickHandler}
            activeRowId={selectedSegregationRow?.id}
            tableBoxClassName="max-h-[500px]"
            ref={prevSegregationRowRef}
          />
        )}
        withSort
        tableWrapperClassname="!mx-0"
      />

      {detailsSearchParams ? (
        <TableTemplate<
          IPortfoSegregationDetailsSearchParams,
          IPortfoSegregationDetailsTableReport
        >
          getDataTable={getPortfoSegregationDetailsTable}
          searchParameters={detailsSearchParams}
          TableUI={({ reports, onAction, sortingType, setSortingType }) => (
            <CommonTableUI
              reports={reports}
              onAction={onAction}
              sortingType={sortingType}
              setSortingType={setSortingType}
              tableBoxClassName="max-h-[500px]"
            />
          )}
          withSort
          tableWrapperClassname="!mx-0"
        />
      ) : null}
    </div>
  );

  return (
    <Modal title="تفکیک پرتفو"
      UI={modalUI}
      onClose={onClose}
      modalBoxClassName="!min-w-0 !w-fit !max-w-[95vw]"
    />
  );
};

export default PortfoSegregationModal;
